import cn from "classnames"
import richText from "utilities/richText"
import DynamicVideo from "components/DynamicVideo"

export default function VideoAndContent({ blok }) {
  const section = cn("bg-white px-5", { "bg-primary": blok.background_color === "primary" })

  const container = cn("flex flex-col gap-4 lg:gap-8 items-center py-12 mx-auto max-w-screen-xl", {
    "lg:flex-row-reverse justify-end": blok.orientation === "content_first",
    "lg:flex-row": blok.orientation === "video_first",
  })

  return (
    <section className={section}>
      <div className={container}>
        <div className="w-full z-10 basis-1/2">
          <DynamicVideo
            component={blok.video[0].component}
            {...blok.video[0]}
            title={blok?.video[0]?.title ?? blok?.heading}
          />
        </div>

        <div className={cn("basis-1/2", { "text-white": blok.background_color === "primary" })}>
          {blok.eyebrow ? (
            <div className="uppercase pb-2 flex">
              <span className={cn("eyebrow text-primary", { "text-white": blok.background_color === "primary" })}>
                {blok.eyebrow}
              </span>
            </div>
          ) : null}
          <h2 className={cn("text-primary mb-6", { "text-white": blok.background_color === "primary" })}>
            {blok.heading}
          </h2>
          <div className="leading-8 prose-p:mb-6">{richText(blok.content)}</div>
        </div>
      </div>
    </section>
  )
}
